<template>
    <div style="margin-left: 1rem; margin-right: 1rem">
        <b-card v-if="!showCadastre" style="border: none; margin-left: 1rem; margin-right: 1rem">
          <b-row v-if="!is_map_mode && !is_map_select_mode">
                <b-col>
                  <b-form-input placeholder="Suchen" type="search" id="search_1" v-model="searchAugr"></b-form-input>
                </b-col>
            <b-col>
              <b-form-input placeholder="Suchen" type="search" v-model="searchAufsin"></b-form-input>
            </b-col>
          </b-row>
            <b-row v-if="!is_map_mode && !is_map_select_mode">
                <b-col style="height: 65vh; overflow: auto">
                    <b-table striped hover selectable sticky-header :items="filteredGroups" :fields="group_fields"
                             select-mode="single"
                             selectedVariant="primary"
                             @row-selected="rowSelectedGroup"
                             ref="group_table"
                             style="height: 100%; max-height: 100%; margin: 0px"
                    >
                        <template v-slot:cell(map)="row">
                            <b-button style="float: right;" variant="primary" size="sm"
                                      v-if="objects !== undefined && currentGroup.key === row.item.key && hasMap"
                                      @click="toggleMapSelectMode">
                                Über die Karte auswählen
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
                <b-col style="height: 65vh; overflow: auto">
                  <b-table striped hover :items="filteredObjects" :fields="object_fields" selectable sticky-header
                             select-mode="single"
                             selectedVariant="primary"
                             @row-selected="rowSelectedObject"
                             ref="object_table"
                             style="height: 100%; max-height: 100%; margin: 0px"
                    >
                        <template v-slot:cell(gps)="row">
                            <b-button style="float: right;" variant="primary" size="sm"
                                      v-if="selected.length > 0 && row.item.gi_aufisn === selected[0].gi_aufisn && hasMap"
                                      @click="toggleMap">
                                Auftragsort markieren
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <b-row v-if="is_map_select_mode">
                <b-col class="pl-0"><h5>Koordinaten für: {{current_gi_match}}</h5></b-col>
                <b-col class="pr-0">
                    <b-button variant="warning" v-on:click="toggleMapSelectMode" class="px-4 float-right mb-2">Objektgruppe wählen
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-if="is_map_select_mode">
                <b-col style="height: 55vh; overflow: auto">
                    <b-table striped hover :items="objects" :fields="object_fields" selectable
                             select-mode="single"
                             selectedVariant="primary"
                             @row-selected="rowSelectedObject"
                             ref="object_table"
                    >
                        <template v-slot:cell(gps)="row">
                        <b-button style="float: right;" variant="primary" size="sm"
                                  v-if="selected.length > 0 && row.item.gi_aufisn === selected[0].gi_aufisn && !is_coordinate_mode"
                                  @click="toggleCoordinateMode(true)">
                            Auftragsort markieren
                        </b-button>
                        <b-button style="float: right;" variant="warning" size="sm"
                                  v-if="selected.length > 0 && row.item.gi_aufisn === selected[0].gi_aufisn && is_coordinate_mode"
                                  @click="toggleCoordinateMode(false)">
                            Markieren abbrechen
                        </b-button>
                        </template>
                    </b-table>
                </b-col>
                <b-col style="height: 55vh; padding: 0; margin-bottom: 0" id="map_select_container"
                       ref="map_select_container">
                </b-col>
            </b-row>
            <b-row v-if="is_map_mode">
                <b-col class="pl-0"><h5>Koordinaten für: {{selected[0].gi_match}}</h5></b-col>
                <b-col class="pr-0">
                    <b-button variant="warning" v-on:click="toggleMap" class="px-4 float-right mb-2">Objekt wählen
                </b-button>
                </b-col>
            </b-row>
            <b-row v-if="is_map_mode">
                <b-col style="height: 55vh; padding: 0; margin-bottom: 0" id="map_container"
                       ref="map_container">
                </b-col>
            </b-row>
        </b-card>
        <cadastre v-else :in-select-mode="true" ref="cadastre" @can-continue="$emit('can-continue', $event)"></cadastre>
    </div>
</template>

<script>
import {arrayContains, Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";

    import StylesControl from 'mapbox-gl-controls/lib/styles';
    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import Cadastre from "@/views/cadastre/cadastre.vue";

    export default {
        name: "task_step2",
      components: {Cadastre},
        props: ['currentStep', 'isVisible'],
        mounted() {
            this.marker = null;
            this.lat = null;
            this.lon = null;
            this.$emit('can-continue', {value: false});
            this.selected_group = this.currentStep.payload.selected_group;
            if (this.selected_group === undefined) {
                this.selected_group = {id: undefined};
            }
            this.settings = this.currentStep.payload.settings;
            this.showLoader();
            let appendix = "";
            if (this.settings && this.settings.hh_alt) {
                appendix = "?all=true"
            }
            // check geo ref
          let modules = sessionStorage.getItem("suite_modules");
          if (modules !== null && modules !== "") {
            modules = JSON.parse(modules);
            if (arrayContains(modules, 11)) {
              this.hasMap = true;
            }
          }
            this.$http.get(
                Server_URL+'/auftragsbuch/data/create/step2/'+this.selected_group.id+appendix
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
                loader: undefined,
                currentGroup: {},
                groups: [],
                objects: undefined,
                objectsMap: {},
                gps: undefined,
                currentGps: null,
                gpsMap: {},
                group_fields: [{key: "titel", label: 'Gruppe wählen'}, {key: "map", label: ""}],
                object_fields: [{key: "gi_match", label: 'Objekt wählen'}, {key: "gps", label: ""}],
                selected: [],

                // todo use later
                commune: "",

                settings: {},
                selected_group: {},
                hasMap: false,
                is_map_mode: false,
                is_map_select_mode: false,
                isInitial: true,
                geoRefPerimeter: "",
                current_gi_match: "",
                is_coordinate_mode: false,
                selectedFeatures: {
                    poly: null,
                    linestring: null,
                    point: null
                },
                searchAugr: '',
                searchAufsin: '',
                showCadastre: false,
            }
        },
        methods: {
          log(e) {
            console.log(e);
          },
          toggleCadastre(show) {
            this.showCadastre = show;
          },
          rowSelectedGroup(items) {
                if (items.length === 0) {
                    this.objects = undefined;
                    this.selected = [];
                    this.currentGroup = {};
                    this.gps = undefined;
                    this.currentGps = null;
                } else {
                    this.objects = this.objectsMap[items[0].key];
                    this.gps = this.gpsMap[items[0].key];
                    this.currentGroup = items[0];
                    if (this.objects.length === 1) {
                        this.$nextTick(() => {
                            this.$refs.object_table.selectRow(0);
                        });
                    }
                }
            },
            rowSelectedObject(items) {
                this.selected = items;
                this.currentGps = null;
                if (!this.isInitial) {
                    this.toggleCoordinateMode(false);
                }
                if (items.length > 0 && this.gps !== undefined && this.gps !== null && this.gps.length > 0) {
                    let obj = items[0];
                    for (let i = 0; i < this.gps.length; i++) {
                        let cur = this.gps[i];
                        if (cur.stamm_auftrag === obj.gi_aufisn) {
                            this.currentGps = cur;
                            break;
                        }
                    }
                }
                if (items.length === 0) {
                    this.current_gi_match = "";
                    this.selectGeometry(-1);
                    this.$emit('can-continue', {value: false});
                } else {
                    this.current_gi_match =  items[0].gi_match;
                    this.selectGeometry(parseInt(items[0].gi_aufisn));
                    this.$emit('can-continue', {value: true});
                }
            },
            setActive: function (payload) {
              if (payload.selected_group === undefined) {
                return
              }
                if (this.selected_group.id !== payload.selected_group.id) {
                    this.selected_group = payload.selected_group;
                    this.groups = [];
                    this.objectsMap = {};
                    this.objects = undefined;
                    this.selected = [];
                    this.currentGroup = {};
                    this.showLoader();
                    this.$http.get(
                        Server_URL+'/auftragsbuch/data/create/step2/'+this.selected_group.id
                    ).then(this.responseOkGet, this.responseError)
                }
                if (this.$emit) {
                    if (this.selected.length === 0) {
                        this.$emit('can-continue', {value: false});
                    } else {
                        this.$emit('can-continue', {value: true});
                    }
                }
            },
            getReturnData: function () {
            let res = {
              selected_augr: null,
              selected_aufisn: null,
              lat: this.lat,
              lon: this.lon,
              entity_id: '',
            };
            if (this.showCadastre) {
              let selection = this.$refs.cadastre.getSelected();
              let augr = undefined;
              for (let i = 0; i < this.groups.length; i++) {
                if (this.groups[i].key === selection.augr) {
                  augr = this.groups[i];
                  break
                }
              }
              let aufisn = undefined;
              let aufisns = this.objectsMap[selection.augr];
              if (aufisns === undefined) {
                aufisns = [];
              }
              for (let i = 0; i < aufisns.length; i++) {
                if (aufisns[i].gi_aufisn === selection.aufisn) {
                  aufisn = aufisns[i];
                  break
                }
              }
              res = {
                selected_augr: augr,
                selected_aufisn: aufisn,
                lat: selection.lat,
                lon: selection.lon,
                entity_id: selection.entity_id,
              };
            } else {
              res = {
                selected_augr: this.currentGroup,
                selected_aufisn: this.selected[0],
                lat: this.lat,
                lon: this.lon,
                entity_id: '',
              };
            }
                return res;
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200 && response.body.status === "ok") {
                    for (let i = response.body.data.augrs.length-1; i >= 0; i--) {
                        if (response.body.data.aufisn_map[response.body.data.augrs[i].key] === undefined) {
                            response.body.data.augrs.splice(i, 1)
                        }
                    }
                    this.groups = response.body.data.augrs;
                    this.objectsMap = response.body.data.aufisn_map;
                    this.gpsMap = response.body.data.gps_map;
                    this.geoRefPerimeter = response.body.data.geo_ref_perimeter;
                    if (this.groups.length === 1) {
                        this.$nextTick(() => {
                            this.$refs.group_table.selectRow(0);
                        });
                    }
                } else {
                    window.location = Redirect_500;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_500;
                }
            },
            toggleMap() {
                this.lat = null;
                this.lon = null;
                let current = this.is_map_mode;
                this.is_map_mode = !this.is_map_mode;
                this.isInitial = true;
                if (!current) {
                    setTimeout(() => {
                        mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
                        this.map = new mapboxgl.Map({
                            container: 'map_container',
                            style: 'mapbox://styles/mapbox/outdoors-v11',
                            center: [10.244990, 50.943359],
                            zoom: 6,
                            minZoom: 5,
                            maxPitch: 0,
                        });

                        this.map.addControl(new StylesControl({
                            styles: [
                                {
                                    label: 'Normal',
                                    styleName: 'Mapbox Streets',
                                    styleUrl: 'mapbox://styles/mapbox/outdoors-v11',
                                }, {
                                    label: 'Satellit',
                                    styleName: 'Satellite',
                                    styleUrl: 'mapbox://styles/mapbox/satellite-streets-v11',
                                },
                            ],
                            onChange: () => this.map.once("style.load", this.queryPlace),
                        }), 'top-left');
                        this.map.addControl(new ZoomControl(), 'bottom-right');
                        const languageControl = new LanguageControl({
                            language: 'de',
                        });
                        this.map.addControl(languageControl);
                        this.geocoder = new MapboxGeocoder({
                            accessToken: mapboxgl.accessToken,
                            mapboxgl: mapboxgl,
                            placeholder: "Suchen",
                            zoom: 19,
                            language: 'de-DE',
                            countries: 'de',
                            marker: false,
                            flyTo: true,
                        });
                        this.geocoder.on("result", (res) => {
                            let coords = res.result.center;
                            let e = {
                                lngLat :
                                    {
                                        lon: coords[0],
                                        lat: coords[1]
                                    }
                            }
                            this.onMapClick(e)
                        });
                        this.map.addControl(
                            this.geocoder
                        );
                        this.map.on('click', this.onMapClick);
                        this.map.once('load', this.queryPlace)
                    });
                } else {
                    this.lat = null;
                    this.lon = null;
                    this.marker = null;
                    this.map.remove();
                    this.map = undefined;
                    this.geocoder = undefined;
                    for (let i = 0; i < this.groups.length; i++) {
                        if (this.groups[i].key === this.currentGroup.key) {
                            this.$nextTick(() => {
                                this.$refs.group_table.selectRow(i);
                                for (let j = 0; j < this.objects.length; j++) {
                                    if (this.selected[0].gi_aufisn === this.objects[j].gi_aufisn) {
                                        this.$nextTick(() => {
                                            this.$refs.object_table.selectRow(j);
                                        });
                                    }
                                }
                            });
                        }
                    }

                }
            },
            queryPlace() {
                setTimeout(() => {
                    this.map.resize();
                    let bounds = null;
                    if (this.currentGps !== null) {
                        if (this.currentGps.wkt.startsWith("POLYGON")) {
                            bounds = this.addPolygon();
                        } else if (this.currentGps.wkt.startsWith("LINESTRING")) {
                            bounds = this.addLineString();
                        } else if (this.currentGps.wkt.startsWith("POINT")) {
                            bounds = this.addPoint();
                        }
                    }
                    if ((bounds !== null || this.geoRefPerimeter !== "") && this.isInitial) {
                        this.isInitial = false;
                        setTimeout(() => {
                            if (bounds !== null) {
                                this.map.fitBounds(bounds, {padding: 100, duration: 500});
                            } else {
                                let sw = this.geoRefPerimeter.split("||")[0].split(",");
                                let ne = this.geoRefPerimeter.split("||")[1].split(",");
                                this.map.fitBounds([
                                    [parseFloat(sw[0]), parseFloat(sw[1])], // southwestern corner of the bounds
                                    [parseFloat(ne[0]), parseFloat(ne[1])] // northeastern corner of the bounds
                                ], {padding: 100, duration: 500});
                            }
                        });
                    }
                });
            },
            toggleMapSelectMode() {
                this.lat = null;
                this.lon = null;
                let current = this.is_map_select_mode;
                this.is_map_select_mode = !this.is_map_select_mode;
                this.isInitial = true;
                if (!current) {
                    setTimeout(() => {
                        mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
                        this.map = new mapboxgl.Map({
                            container: 'map_select_container',
                            style: 'mapbox://styles/mapbox/outdoors-v11',
                            center: [10.244990, 50.943359],
                            zoom: 6,
                            minZoom: 5,
                            maxPitch: 0,
                        });

                        this.map.addControl(new StylesControl({
                            styles: [
                                {
                                    label: 'Normal',
                                    styleName: 'Mapbox Streets',
                                    styleUrl: 'mapbox://styles/mapbox/outdoors-v11',
                                }, {
                                    label: 'Satellit',
                                    styleName: 'Satellite',
                                    styleUrl: 'mapbox://styles/mapbox/satellite-streets-v11',
                                },
                            ],
                            onChange: () => this.map.once("style.load", this.displayObjects),
                        }), 'top-left');
                        this.map.addControl(new ZoomControl(), 'bottom-right');
                        const languageControl = new LanguageControl({
                            language: 'de',
                        });
                        this.map.addControl(languageControl);
                        this.geocoder = new MapboxGeocoder({
                            accessToken: mapboxgl.accessToken,
                            mapboxgl: mapboxgl,
                            placeholder: "Suchen",
                            zoom: 19,
                            language: 'de-DE',
                            countries: 'de',
                            marker: false,
                            flyTo: true,
                        });
                        this.geocoder.on("result", (res) => {
                            let coords = res.result.center;
                            let e = {
                                lngLat :
                                    {
                                        lng: coords[0],
                                        lat: coords[1]
                                    }
                            };
                            this.onMapClick(e)
                        });
                        this.map.addControl(
                            this.geocoder
                        );
                        this.map.once('load', this.displayObjects)
                    });
                } else {
                    this.lat = null;
                    this.lon = null;
                    this.marker = null;
                    this.map.remove();
                    this.map = undefined;
                    this.geocoder = undefined;
                    this.selectedFeatures = {
                        poly: null,
                        linestring: null,
                        point: null
                    };
                    for (let i = 0; i < this.groups.length; i++) {
                        if (this.groups[i].key === this.currentGroup.key) {
                            this.$nextTick(() => {
                                this.$refs.group_table.selectRow(i);
                                if (this.selected.length > 0) {
                                    for (let j = 0; j < this.objects.length; j++) {
                                        if (this.selected[0].gi_aufisn === this.objects[j].gi_aufisn) {
                                            this.$nextTick(() => {
                                                this.$refs.object_table.selectRow(j);
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    }

                }
            },
            displayObjects() {
                setTimeout(() => {
                    this.map.resize();
                    this.addPolygones();
                    this.addLineStrings();
                    this.addPoints();
                    if (this.selectedFeatures.poly !== null) {
                        this.map.setFeatureState(
                            { source: 'poly', id: this.selectedFeatures.poly },
                            { selected: true }
                        );
                    } else if (this.selectedFeatures.linestring !== null) {
                        this.map.setFeatureState(
                            { source: 'linestring', id: this.selectedFeatures.linestring },
                            { selected: true }
                        );
                    } else if (this.selectedFeatures.point !== null) {
                        this.map.setFeatureState(
                            { source: 'pointcoord', id: this.selectedFeatures.linestring },
                            { selected: true }
                        );
                    }
                    if (this.geoRefPerimeter !== "" && this.isInitial) {
                        this.toggleCoordinateMode(false);
                        this.isInitial = false;
                        setTimeout(() => {
                                let sw = this.geoRefPerimeter.split("||")[0].split(",");
                                let ne = this.geoRefPerimeter.split("||")[1].split(",");
                                this.map.fitBounds([
                                    [parseFloat(sw[0]), parseFloat(sw[1])], // southwestern corner of the bounds
                                    [parseFloat(ne[0]), parseFloat(ne[1])] // northeastern corner of the bounds
                                ], {padding: 100, duration: 500});
                        });
                    }
                });
            },
            getPolygonBoundingBox() {
                let poly = this.currentGps.wkt;
                if (poly.includes("\\r\\n")) {
                    poly = poly.split("\\r\\n")[0];
                }
                poly = poly.replace("POLYGON(", "");
                poly = poly.replace(")", "");
                let splits = poly.split(",");
                let coords = [];
                for (let i = 0; i < splits.length; i++) {
                    let item = splits[i].split(" ");
                    coords.push([parseFloat(item[1]), parseFloat(item[0])])
                }
                coords.push(coords[0]);
                let bounds = new (mapboxgl.LngLatBounds);
                coords.forEach(el => {
                    bounds.extend(el)
                });
                return bounds;
            },
            addPolygon() {
                let poly = this.currentGps.wkt;
                if (poly.includes("\\r\\n")) {
                    poly = poly.split("\\r\\n")[0];
                }
                poly = poly.replace("POLYGON(", "");
                poly = poly.replace(")", "");
                let splits = poly.split(",");
                let coords = [];
                for (let i = 0; i < splits.length; i++) {
                    let item = splits[i].split(" ");
                    coords.push([parseFloat(item[1]), parseFloat(item[0])])
                }
                coords.push(coords[0]);
                this.map.addSource('poly', {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Polygon',
                            'coordinates': [
                                coords
                            ]
                        }
                    }
                });
                this.map.addLayer({
                    'id': 'maine',
                    'type': 'fill',
                    'source': 'poly', // reference the data source
                    'layout': {},
                    'paint': {
                        'fill-color': '#0080ff', // blue color fill
                        'fill-opacity': 0.25
                    }
                });
                this.map.addLayer({
                    'id': 'outline',
                    'type': 'line',
                    'source': 'poly',
                    'layout': {},
                    'paint': {
                        'line-color': '#000',
                        'line-width': 1
                    }
                });
                let bounds = new (mapboxgl.LngLatBounds);
                coords.forEach(el => {
                    bounds.extend(el)
                });
                return bounds;
            },
            addPolygones() {
                if (this.gps === undefined || this.gps === null || this.gps.length === 0) {
                    return;
                }
                let features = [];
                let polyPoints = [];
                for (let i = 0; i < this.gps.length; i++) {
                    let current = this.gps[i];
                    if (!current.wkt.startsWith("POLYGON")) {
                        continue;
                    }
                    let poly = current.wkt;
                    if (poly.includes("\\r\\n")) {
                        poly = poly.split("\\r\\n")[0];
                    }
                    poly = poly.replace("POLYGON(", "");
                    poly = poly.replace(")", "");
                    let splits = poly.split(",");
                    let coords = [];
                    for (let i = 0; i < splits.length; i++) {
                        let item = splits[i].split(" ");
                        coords.push([parseFloat(item[1]), parseFloat(item[0])])
                    }
                    coords.push(coords[0]);
                    features.push({
                        'type': 'Feature',
                        'id': current.stamm_auftrag,
                        'geometry': {
                            'type': 'Polygon',
                            'coordinates': [
                                coords
                            ]
                        }
                    });
                    polyPoints.push({
                        'type': 'Feature',
                        'id': current.stamm_auftrag,
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [current.lng, current.lat]
                        }
                    })
                }
                this.currentSourcePoly = {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': features
                    }
                };
                this.currentSourcePointPoly = {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': polyPoints
                    }
                };
                this.map.addSource("poly", this.currentSourcePoly);
                this.map.addSource("poly_points", this.currentSourcePointPoly);
                this.map.addLayer({
                    'id': 'fill_poly',
                    'type': 'fill',
                    'source': 'poly', // reference the data source
                    'layout': {},
                    'minzoom': 15,
                    'paint': {
                        'fill-color': [
                            'case',
                            ['boolean', ['feature-state', 'selected'], false],
                            '#d6d50f',
                            '#0080ff'
                        ], // blue or yellow color fill
                        'fill-opacity': 0.25
                    }
                }); //'#0080ff'
                this.map.addLayer({
                    'id': 'outline_poly',
                    'type': 'line',
                    'source': 'poly',
                    'layout': {},
                    'minzoom': 15,
                    'paint': {
                        'line-color': '#000',
                        'line-width': [
                            'case',
                            ['boolean', ['feature-state', 'selected'], false],
                            2,
                            1
                        ]
                    }
                });
                this.map.addLayer({
                    'id': 'poly_points',
                    'type': 'circle',
                    'maxzoom': 15,
                    'source': 'poly_points',
                    'paint': {
                        'circle-radius': 9,
                        'circle-color': [
                            'case',
                            ['boolean', ['feature-state', 'selected'], false],
                            '#d6d50f',
                            '#21bcff'
                        ], // blue or yellow color fill
                        'circle-stroke-width': [
                            'case',
                            ['boolean', ['feature-state', 'selected'], false],
                            2,
                            2
                        ],
                        'circle-stroke-color': '#000',
                    },
                });
            },
            getLineStringBoundingBox() {
                let line = this.currentGps.wkt;
                if (line.includes("\\r\\n")) {
                    line = line.split("\\r\\n")[0];
                }
                line = line.replace("LINESTRING(", "");
                line = line.replace(")", "");
                let splits = line.split(",");
                let coords = [];
                for (let i = 0; i < splits.length; i++) {
                    let item = splits[i].split(" ");
                    coords.push([parseFloat(item[1]), parseFloat(item[0])])
                }
                let bounds = new (mapboxgl.LngLatBounds);
                coords.forEach(el => {
                    bounds.extend(el)
                });
                return bounds;
            },
            addLineString() {
                let line = this.currentGps.wkt;
                if (line.includes("\\r\\n")) {
                    line = line.split("\\r\\n")[0];
                }
                line = line.replace("LINESTRING(", "");
                line = line.replace(")", "");
                let splits = line.split(",");
                let coords = [];
                for (let i = 0; i < splits.length; i++) {
                    let item = splits[i].split(" ");
                    coords.push([parseFloat(item[1]), parseFloat(item[0])])
                }
                this.map.addSource('linestring', {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'LineString',
                            'coordinates': coords
                        }
                    }
                });
                this.map.addLayer({
                    'id': 'route',
                    'type': 'line',
                    'source': 'linestring',
                    'layout': {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    'paint': {
                        'line-color': '#0080ff',
                        'line-width': 5
                    }
                });
                let bounds = new (mapboxgl.LngLatBounds);
                coords.forEach(el => {
                    bounds.extend(el)
                });
                return bounds;
            },
            addLineStrings() {
                if (this.gps === undefined || this.gps === null || this.gps.length === 0) {
                    return;
                }
                let features = [];
                for (let i = 0; i < this.gps.length; i++) {
                    let current = this.gps[i];
                    if (!current.wkt.startsWith("LINESTRING")) {
                        continue;
                    }
                    let line = current.wkt;
                    if (line.includes("\\r\\n")) {
                        line = line.split("\\r\\n")[0];
                    }
                    line = line.replace("LINESTRING(", "");
                    line = line.replace(")", "");
                    let splits = line.split(",");
                    let coords = [];
                    for (let i = 0; i < splits.length; i++) {
                        let item = splits[i].split(" ");
                        coords.push([parseFloat(item[1]), parseFloat(item[0])])
                    }
                    features.push({
                        'type': 'Feature',
                        'id': current.stamm_auftrag,
                        'geometry': {
                            'type': 'LineString',
                            'coordinates': coords
                        }
                    });
                }
                this.currentSourceLineString = {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': features
                    }
                };
                this.map.addSource("linestring", this.currentSourceLineString)
                this.map.addLayer({
                    'id': 'route_linestring',
                    'type': 'line',
                    'source': 'linestring',
                    'layout': {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    'paint': {
                        'line-color': [
                            'case',
                            ['boolean', ['feature-state', 'selected'], false],
                            '#d6d50f',
                            '#0080ff'
                        ], // blue or yellow color fill
                        'line-width': [
                            'case',
                            ['boolean', ['feature-state', 'selected'], false],
                            7,
                            5
                        ], // blue or yellow color fill
                    }
                });
            },
            getPointBoundingBox() {
                let point = this.currentGps.wkt;
                if (point.includes("\\r\\n")) {
                    point = point.split("\\r\\n")[0];
                }
                point = point.replace("POINT(", "");
                point = point.replace(")", "");
                let splits = point.split(",");
                let coords = [];
                for (let i = 0; i < splits.length; i++) {
                    let item = splits[i].split(" ");
                    coords.push([parseFloat(item[1]), parseFloat(item[0])])
                }
                let bounds = new (mapboxgl.LngLatBounds);
                coords.forEach(el => {
                    bounds.extend(el)
                });
                return bounds;
            },
            addPoint() {
                let point = this.currentGps.wkt;
                if (point.includes("\\r\\n")) {
                    point = point.split("\\r\\n")[0];
                }
                point = point.replace("POINT(", "");
                point = point.replace(")", "");
                let splits = point.split(",");
                let coords = [];
                for (let i = 0; i < splits.length; i++) {
                    let item = splits[i].split(" ");
                    coords.push([parseFloat(item[1]), parseFloat(item[0])])
                }
                this.map.addSource('pointcoord', {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': coords[0]
                        }
                    }
                });
                this.map.addLayer({
                    'id': 'point',
                    'type': 'circle',
                    'source': 'pointcoord',
                    'paint': {
                        'circle-radius': 7,
                        'circle-color': '#0080ff',
                        'circle-stroke-width': 1,
                        'circle-stroke-color': '#000',
                    },
                });
                let bounds = new (mapboxgl.LngLatBounds);
                coords.forEach(el => {
                    bounds.extend(el)
                });
                return bounds;
            },
            addPoints() {
                if (this.gps === undefined || this.gps === null || this.gps.length === 0) {
                    return;
                }
                let features = [];
                for (let i = 0; i < this.gps.length; i++) {
                    let current = this.gps[i];
                    if (!current.wkt.startsWith("POINT")) {
                        continue;
                    }
                    let point = current.wkt;
                    if (point.includes("\\r\\n")) {
                        point = point.split("\\r\\n")[0];
                    }
                    point = point.replace("POINT(", "");
                    point = point.replace(")", "");
                    let splits = point.split(",");
                    let coords = [];
                    for (let i = 0; i < splits.length; i++) {
                        let item = splits[i].split(" ");
                        coords.push([parseFloat(item[1]), parseFloat(item[0])])
                    }
                    features.push({
                        'type': 'Feature',
                        'id': current.stamm_auftrag,
                        'geometry': {
                            'type': 'Point',
                            'coordinates': coords[0]
                        }
                    });
                }
                this.currentSourcePoint = {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': features
                    }
                };
                this.map.addSource("pointcoord", this.currentSourcePoint)
                this.map.addLayer({
                    'id': 'point',
                    'type': 'circle',
                    'source': 'pointcoord',
                    'paint': {
                        'circle-radius': 7,
                        'circle-color': [
                            'case',
                            ['boolean', ['feature-state', 'selected'], false],
                            '#d6d50f',
                            '#0080ff'
                        ], // blue or yellow color fill
                        'circle-stroke-width': [
                            'case',
                            ['boolean', ['feature-state', 'selected'], false],
                            2,
                            1
                        ],
                        'circle-stroke-color': '#000',
                    },
                });
            },
            toggleCoordinateMode(val) {
                if (this.is_coordinate_mode === val && !this.isInitial) {
                    return;
                }
                if (!this.is_map_select_mode) {
                    return;
                }
                this.is_coordinate_mode = val;
                if (this.is_coordinate_mode) {
                    this.map.off('mousemove', 'fill_poly', this.onMouseEnter);
                    this.map.off('mouseleave', 'fill_poly', this.onMouseExit);
                    this.map.off('mousemove', 'route_linestring', this.onMouseEnter);
                    this.map.off('mouseleave', 'route_linestring', this.onMouseExit);
                    this.map.off('mousemove', 'point', this.onMouseEnter);
                    this.map.off('mouseleave', 'point', this.onMouseExit);
                    this.map.off('mousemove', 'poly_points', this.onMouseEnter);
                    this.map.off('mouseleave', 'poly_points', this.onMouseExit);
                    this.map.on('click', this.onMapClick);
                    this.map.off('click', 'fill_poly', this.onPolyClicked);
                    this.map.off('click', 'route_linestring', this.onLinestringClicked);
                    this.map.off('click', 'point', this.onPointClicked);
                    this.map.off('click', 'poly_points', this.onPolyClicked);

                } else {
                    if (this.marker !== null) {
                        this.marker.remove();
                        this.marker = null;
                        this.lat = null;
                        this.lon = null;
                    }
                    this.map.on('click', 'fill_poly', this.onPolyClicked);
                    this.map.on('click', 'route_linestring', this.onLinestringClicked);
                    this.map.on('click', 'point', this.onPointClicked);
                    this.map.off('click', this.onMapClick);
                    this.map.on('mousemove', 'fill_poly', this.onMouseEnter);
                    this.map.on('mouseleave', 'fill_poly', this.onMouseExit);
                    this.map.on('mousemove', 'route_linestring', this.onMouseEnter);
                    this.map.on('mouseleave', 'route_linestring', this.onMouseExit);
                    this.map.on('mousemove', 'point', this.onMouseEnter);
                    this.map.on('mouseleave', 'point', this.onMouseExit);
                    this.map.on('mousemove', 'poly_points', this.onMouseEnter);
                    this.map.on('mouseleave', 'poly_points', this.onMouseExit);
                    this.map.on('click', 'poly_points', this.onPolyClicked);

                }
            },
            onPolyClicked(e) {
                if (e.features.length > 0) {
                    let id = e.features[0].id;
                    if (this.selectedFeatures.poly === id) {
                        this.map.setFeatureState(
                            { source: 'poly', id: id },
                            { selected: false }
                        );
                        this.selectedFeatures.poly = null;
                        this.$refs.object_table.clearSelected();
                    } else {
                        if (this.selectedFeatures.poly !== null) {
                            this.map.setFeatureState(
                                { source: 'poly', id: this.selectedFeatures.poly },
                                { selected: false }
                            );
                            this.selectedFeatures.poly = null;
                        } else if (this.selectedFeatures.linestring !== null) {
                            this.map.setFeatureState(
                                { source: 'linestring', id: this.selectedFeatures.linestring },
                                { selected: false }
                            );
                            this.selectedFeatures.linestring = null;
                        } else if (this.selectedFeatures.point !== null) {
                            this.map.setFeatureState(
                                { source: 'pointcoord', id: this.selectedFeatures.point },
                                { selected: false }
                            );
                            this.selectedFeatures.point = null;
                        }
                        this.map.setFeatureState(
                            { source: 'poly', id: id },
                            { selected: true }
                        );
                        this.selectedFeatures.poly = id;
                        for (let i = 0; i < this.objects.length; i++) {
                            let cur = this.objects[i];
                            if (parseInt(cur.gi_aufisn) === id) {
                                this.$refs.object_table.selectRow(i);
                                break
                            }
                        }
                    }
                }
            },
            onLinestringClicked(e) {
                if (e.features.length > 0) {
                    let id = e.features[0].id;
                    if (this.selectedFeatures.linestring === id) {
                        this.map.setFeatureState(
                            { source: 'linestring', id: id },
                            { selected: false }
                        );
                        this.selectedFeatures.linestring = null;
                        this.$refs.object_table.clearSelected();
                    } else {
                        if (this.selectedFeatures.poly !== null) {
                            this.map.setFeatureState(
                                { source: 'poly', id: this.selectedFeatures.poly },
                                { selected: false }
                            );
                            this.selectedFeatures.poly = null;
                        } else if (this.selectedFeatures.linestring !== null) {
                            this.map.setFeatureState(
                                { source: 'linestring', id: this.selectedFeatures.linestring },
                                { selected: false }
                            );
                            this.selectedFeatures.linestring = null;
                        } else if (this.selectedFeatures.point !== null) {
                            this.map.setFeatureState(
                                { source: 'pointcoord', id: this.selectedFeatures.point },
                                { selected: false }
                            );
                            this.selectedFeatures.point = null;
                        }
                        this.map.setFeatureState(
                            { source: 'linestring', id: id },
                            { selected: true }
                        );
                        this.selectedFeatures.linestring = id;
                        for (let i = 0; i < this.objects.length; i++) {
                            let cur = this.objects[i];
                            if (parseInt(cur.gi_aufisn) === id) {
                                this.$refs.object_table.selectRow(i);
                                break
                            }
                        }
                    }
                }
            },
            onPointClicked(e) {
                if (e.features.length > 0) {
                    let id = e.features[0].id;
                    if (this.selectedFeatures.point === id) {
                        this.map.setFeatureState(
                            { source: 'pointcoord', id: id },
                            { selected: false }
                        );
                        this.selectedFeatures.point = null;
                        this.$refs.object_table.clearSelected();
                    } else {
                        if (this.selectedFeatures.poly !== null) {
                            this.map.setFeatureState(
                                { source: 'poly', id: this.selectedFeatures.poly },
                                { selected: false }
                            );
                            this.selectedFeatures.poly = null;
                        } else if (this.selectedFeatures.linestring !== null) {
                            this.map.setFeatureState(
                                { source: 'linestring', id: this.selectedFeatures.linestring },
                                { selected: false }
                            );
                            this.selectedFeatures.linestring = null;
                        } else if (this.selectedFeatures.point !== null) {
                            this.map.setFeatureState(
                                { source: 'pointcoord', id: this.selectedFeatures.point },
                                { selected: false }
                            );
                            this.selectedFeatures.point = null;
                        }
                        this.map.setFeatureState(
                            { source: 'pointcoord', id: id },
                            { selected: true }
                        );
                        this.selectedFeatures.point = id;
                        for (let i = 0; i < this.objects.length; i++) {
                            let cur = this.objects[i];
                            if (parseInt(cur.gi_aufisn) === id) {
                                this.$refs.object_table.selectRow(i);
                                break
                            }
                        }
                    }
                }
            },
            selectGeometry(gi_aufisn) {
                if (!this.is_map_select_mode) {
                    return;
                }
              if (gi_aufisn === -1) {
                  if (this.selectedFeatures.poly !== null) {
                      this.map.setFeatureState(
                          { source: 'poly', id: this.selectedFeatures.poly },
                          { selected: false }
                      );
                      this.selectedFeatures.poly = null;
                  } else if (this.selectedFeatures.linestring !== null) {
                      this.map.setFeatureState(
                          { source: 'linestring', id: this.selectedFeatures.linestring },
                          { selected: false }
                      );
                      this.selectedFeatures.linestring = null;
                  } else if (this.selectedFeatures.point !== null) {
                      this.map.setFeatureState(
                          { source: 'pointcoord', id: this.selectedFeatures.point },
                          { selected: false }
                      );
                      this.selectedFeatures.point = null;
                  }
              } else {
                  if (this.selectedFeatures.poly !== null && this.selectedFeatures.poly !== gi_aufisn) {
                      this.map.setFeatureState(
                          { source: 'poly', id: this.selectedFeatures.poly },
                          { selected: false }
                      );
                      this.selectedFeatures.poly = null;
                  } else if (this.selectedFeatures.linestring !== null && this.selectedFeatures.poly !== gi_aufisn) {
                      this.map.setFeatureState(
                          { source: 'linestring', id: this.selectedFeatures.linestring },
                          { selected: false }
                      );
                      this.selectedFeatures.linestring = null;
                  } else if (this.selectedFeatures.point !== null && this.selectedFeatures.poly !== gi_aufisn) {
                      this.map.setFeatureState(
                          { source: 'pointcoord', id: this.selectedFeatures.point },
                          { selected: false }
                      );
                      this.selectedFeatures.point = null;
                  }
                  if (this.currentGps !== null) {
                      if (this.currentGps.wkt.startsWith("POLYGON")) {
                          this.map.setFeatureState(
                              { source: 'poly', id: gi_aufisn },
                              { selected: true }
                          );
                          this.selectedFeatures.poly = gi_aufisn;
                          setTimeout(() => {
                              this.map.fitBounds(this.getPolygonBoundingBox(), {padding: 200, duration: 500});
                          });
                      } else if (this.currentGps.wkt.startsWith("LINESTRING")) {
                          this.map.setFeatureState(
                              { source: 'linestring', id: gi_aufisn },
                              { selected: true }
                          );
                          this.selectedFeatures.linestring = gi_aufisn;
                          setTimeout(() => {
                              this.map.fitBounds(this.getLineStringBoundingBox(), {padding: 200, duration: 500});
                          });
                      } else if (this.currentGps.wkt.startsWith("POINT")) {
                          this.map.setFeatureState(
                              { source: 'pointcoord', id: gi_aufisn },
                              { selected: true }
                          );
                          this.selectedFeatures.point = gi_aufisn;
                          setTimeout(() => {
                              this.map.fitBounds(this.getPointBoundingBox(), {padding: 200, duration: 500});
                          });
                      }
                  }
              }
            },
            onMapClick(e) {
                if (this.selected.length < 1) {
                    return;
                }
                this.lat = e.lngLat.lat;
                this.lon = e.lngLat.lng;

                if (this.marker === null) {
                    let el = document.createElement('div');
                    el.className = 'marker';

                    this.marker = new mapboxgl.Marker({
                        element: el,
                        anchor: 'center',
                    })
                        .setLngLat([this.lon, this.lat])
                        .addTo(this.map);
                } else {
                    this.marker.setLngLat([this.lon, this.lat])
                }
            },
            onMouseEnter() {
                this.map.getCanvasContainer().style.cursor = 'pointer';
            },
            onMouseExit() {
                this.map.getCanvasContainer().style.cursor = '';
            }
        },
        computed: {
          filteredGroups() {
            return this.groups.filter(group => {
              return group.titel.toLowerCase().includes(this.searchAugr.toLowerCase());
            });
          },
          filteredObjects() {
            if (this.objects && this.objects.length) {
              return this.objects.filter(object => {
                return object.gi_match.toLowerCase().includes(this.searchAufsin.toLowerCase());
              });
            } else {
              return [];
            }
          }
        }
    }
</script>

<style>
    .marker {
        background-image: url('../../../../public/mangel_marker.png');
        background-size: cover;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;
    }

    .form-control:disabled {
        color: black;
    }

    .text-black {
        color: black;
    }
</style>
